<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('collectionManagement')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('group')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="searchleft">
                        <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                            <el-form-item :label="$t('groupName')">
                                <el-input v-model="searchform.blurry"  @click="$router.push('/user')"  size="small" :placeholder="$t('groupName')"></el-input>
                            </el-form-item>
                            <el-form-item v-if="this.user.user.roles[0].id == 1" :label="$t('zuc')">
                                <el-select size="small" v-model="searchform.principalId" style="width:180px;" :placeholder="$t('pleaseZhuguan')"  >
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option v-for="(item,index) in principallist" :label="item.nickName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-if="this.user.user.roles[0].id == 1" :label="$t('bookName')">
                                <el-select size="small" v-model="searchform.accountId" style="width:180px;" :placeholder="$t('pleaseZhangqi')"  >
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option v-for="(item,index) in accountlist" :label="item.bookName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="searchright" v-if="this.user.user.roles[0].id == 1 || this.user.user.roles[0].id == 11">
                        <el-button size="small" type="primary" @click="openadd">+{{$t('addgroup')}}</el-button>
                    </div>
                    <div class="top"></div>
                    <el-table :data="list" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="groupName" :label="$t('groupName')"></el-table-column>
                        <el-table-column prop="target" :label="$t('mubiao')"></el-table-column>
                        <el-table-column prop="principalName" :label="$t('zucmc')"></el-table-column>
                        <el-table-column prop="accountName" :label="$t('bookName')"></el-table-column>
                        <!-- <el-table-column size="small" prop="nation" label="国家"></el-table-column> -->
                        <el-table-column v-if="this.user.user.roles[0].id == 1" prop="jobName" :label="$t('operator')" width="150">
                            <template slot-scope="scope">
                                <el-button size="small" @click="openedit(scope.row)" type="primary" icon="el-icon-edit"
                                    circle plain style="margin-right:5px;"></el-button>
                                <el-popconfirm :title="$t('isDel')" @confirm="deleteproduct(scope.row)">
                                    <el-button size="small" type="warning" icon="el-icon-delete-solid" circle slot="reference" plain></el-button>
                                </el-popconfirm>
                                <el-tooltip style="margin-left:5px;" class="item" effect="dark" :content="$t('cxxzcy')" placement="top">
                                    <el-button size="small" @click="openuser(scope.row)" type="primary" icon="el-icon-menu" circle plain></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="this.user.user.roles[0].id == 2 || this.user.user.roles[0].id == 11" prop="jobName" :label="$t('operator')" width="150">
                            <template slot-scope="scope">
                                <el-tooltip style="margin-left:5px;" class="item" effect="dark" :content="$t('cxxzcy')" placement="top">
                                    <el-button size="small" @click="openuser(scope.row)" type="primary" icon="el-icon-menu" circle plain></el-button>
                                </el-tooltip>
                                <el-tooltip style="margin-left:5px;" class="item" effect="dark" :content="$t('dc1')" placement="top">
                                    <el-button size="small" @click="daycall(scope.row)" type="primary" icon="el-icon-phone-outline" circle plain></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
            </div>
        </div>
        <pop-up :title="status == 1 ? $t('addgroup') : $t('editgroup')" :isshow="showadd" :haveconfirm="true" @close="getclose" @confirm="getconfirm">
            <div slot="box">
                <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small">
                    <el-form-item :label="$t('groupName')" prop="groupName" style="width:350px;">
                        <el-input v-model="form.groupName" />
                    </el-form-item>
                    <el-form-item :label="$t('mubiao')" prop="target" style="width:300px;">
                        <el-input-number v-model="form.target" :min="1" :max="100"/>
                    </el-form-item>
                    <el-form-item :label="$t('zucmc')" prop="principalId">
                        <el-select size="small" v-model="form.principalId" filterable :placeholder="$t('qxzzucmc')"  style="width:300px;">
                            <el-option
                            v-for="item in principallist"
                            :key="item.id"
                            :label="item.nickName"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('bookName')" prop="accountId">
                        <el-select size="small" v-model="form.accountId" filterable :placeholder="$t('qxzzqmc')"  style="width:300px;">
                            <el-option
                            v-for="item in accountlist"
                            :key="item.id"
                            :label="item.bookName"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                options: [{
                    value: 'mx',
                    label: '墨西哥'
                    }, {
                    value: 'pe',
                    label: '秘鲁'
                    }],
                form: {
                    id: null,
                    groupName: null,
                    target: null,
                    principalName: null,
                    principalId: null,
                    accountId: null,
                    accountName: null,
                    nation:null
                },
                rules: {
                    groupName:[{required:true,message:this.$t('qsrxzmc'),trigger:'blur'}],
                    target:[{required:true,trigger:'blur'}],
                    principalId:[{required:true,trigger:'blur'}],
                    accountId:[{required:true,trigger:'blur'}],
                },
                defaultProps: {
                    label: "name",
                    isLeaf: 'isLeaf'
                },
                searchform: {
                    blurry: "",
                },
                total: 1,
                pageNo: 1,
                pageSize: 10,
                loading: false,
                showadd: false,
                roleId:2,
                accountlist: [],
                principallist:[],
                list: [],
                value1:[],
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
            this.getprincipal()
            this.getaccount()
        },
        methods: {
            openuser(row){
                this.$router.push({path:"/user",query:{roleId:3,groupId:row.id}})
            },
            daycall(row){
                this.$router.push({path:"/daycall",query:{accountId:row.accountId,bookName:row.accountName}})
            },
            openadd() {
                this.getprincipal()
                this.showadd = true
                this.status = 1
                this.form = {
                    id: null,
                    groupName: null,
                    target: null,
                    principalName: null,
                    principalId: null,
                    accountId: null,
                    nation:localStorage.getItem("nation"),
                    accountName: null
                }
            },
            openedit(row) {
                this.status = 2
                this.getprincipal()
                this.getaccount()
                this.form.id = row.id
                this.form.groupName = row.groupName
                this.form.target = row.target
                this.form.principalName = row.principalName
                this.form.accountName = row.accountName
                this.form.principalId = row.principalId
                this.form.accountId = row.accountId
                this.form.nation = row.nation
                this.showadd = true
            },
            getprincipal() {
                _api.get(apiurl.users, {
                    roleId: 2,
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.principallist = res.content
                })
            },
            getaccount() {
                _api.get(apiurl.accountBook, {
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.accountlist = res.data
                })
            },
            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },
            deleteproduct(row) {
                _api.delete(apiurl.group, row.id).then(res => {
                    this.$notify({
                        title: this.$t('success'),
                        message: this.$t('delSuccess'),
                        type: 'success'
                    });
                    this.pageNo = 1
                    this.getList()

                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    });
                })
            },
            getconfirm() {
                if(this.form.groupName == null || this.form.groupName == ""){
                    this.$message.error(this.$t('qsrxzmc'))
                    return
                }
                if(this.form.principalId == null || this.form.principalId == ""){
                    this.$message.error(this.$t('qxzzgmc'))
                    return
                }
                if(this.form.accountId == null || this.form.accountId == ""){
                    this.$message.error(this.$t('qxzzqmc'))
                    return
                }
                if(this.form.target == null || this.form.target == ""){
                    this.$message.error(this.$t('mbbnwk'))
                    return
                }
                if (this.status == 1) { //如果是添加
                    _api.post(apiurl.group, this.form).then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('addSuccess')
                        })
                        this.pageNo = 1
                        this.getList()
                        this.showadd = false
                        this.form = {
                            id: null,
                            groupName: null,
                            target: null,
                            principalName: null,
                            principalId: null,
                            accountId: null,
                            nation:localStorage.getItem("nation"),
                            accountName: null
                        }

                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                } else { //如果是编辑
                    _api.put(apiurl.group, this.form).then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('editSuccess')
                        })
                        this.pageNo = 1
                        this.getList()
                        this.showadd = false
                        this.form = {
                            id: null,
                            groupName: null,
                            target: null,
                            principalName: null,
                            principalId: null,
                            accountId: null,
                            nation:localStorage.getItem("nation"),
                            accountName: null
                        }
                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                }
                  
            },
            getList() {
                this.loading = true
                _api.get(apiurl.group, {
                    page: this.pageNo,
                    size: this.pageSize,
                    blurry: this.searchform.blurry,
                    principalId: this.searchform.principalId,
                    accountId: this.searchform.accountId,
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.loading = false
                    this.blurry=null
                    this.principalId=null
                    this.accountId=null
                    this.list = res.data.list
                    this.total = res.data.total
                })
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                console.log(data)
                this.pageNo = data
                this.getList()
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>